<template>
  <div class="container-fluid">
    <div class="row">
      <div class="mb-3">
        <a
          v-if="!AddMode"
          class="d-inline float-right mx-2 mt-1"
          href="javascript:;"
          @click="
            AddMode = !AddMode
            addnew()
          "
          title="افزودن تماس جدید"
        >
          <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
        </a>
        <a v-if="AddMode" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddMode = !AddMode" title="لغو افزودن">
          <h4><i class="fas fa-times text-danger"></i></h4>
        </a>
      </div>

      <div v-if="CommunicationList.length < 1 && !AddMode" class="col-12 p-4 border Rounded">
        <h4>تماسی ثبت نشده است.</h4>
      </div>
      <div v-if="AddMode" class="col-12" id="AddAdress">
        <div class="row">
          <div class="col-lg-3 col-12 p-2">
            <small id="Lbltarix"> تاریخ</small>
            <date-picker color="dimgray" v-model="DataAxios.ArryfildValue.Date" clearable :editable="true" placeholder=" تاریخ "></date-picker>
          </div>
          <div class="col-lg-3 col-12 p-2">
            <small id="LblTime"> زمان</small>
            <date-picker type="time" color="dimgray" v-model="DataAxios.ArryfildValue.Time" clearable :editable="true" placeholder=" زمان "></date-picker>
          </div>
          <div class="col-lg-3 col-12 p-2">
            <small id="LblPersonel"> پرسنل</small>
            <SearchableCombo :edit="false" :grp="CustomerId" :code="null" @ResultCombo="GetResultPersonel" :rownumintable="3" :defaultvalue="DataAxios.ArryfildValue.tblPersonelId" :action="'TblCrmCombo/GetPersonelCombo'" :method="'POST'" :idinput="'Personel'" :keyItem="'Personel'" :disabled="false">
            </SearchableCombo>
          </div>
          <div class="col-lg-3 col-12 p-2">
            <small id="LblNatije"> نتیجه تماس</small>
            <SearchableCombo :edit="false" :grp="24" :code="null" @ResultCombo="GetResultNatije" :rownumintable="3" :defaultvalue="DataAxios.ArryfildValue.tblComboGrp24Result" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'Natije'" :keyItem="'Natije'" :disabled="false">
            </SearchableCombo>
          </div>
          <div class="col-lg-6 col-12 p-2">
            <small id="LblResult"> اقدامات انجام شده </small>
            <textarea type="text" class="for form-control" v-model="DataAxios.ArryfildValue.Result"> </textarea>
          </div>
          <div class="col-lg-3 col-12 p-2">
            <small id="LblResult"> مدت زمان تماس (دقیقه)</small>
            <input type="text" class="for form-control" v-model="DataAxios.ArryfildValue.Duration" />
          </div>
          <div class="col-lg-3 col-12 p-2">
            <small id="LblResult">کاربر ثبت کننده</small>
            <input disabled :value="$session.get('UserInfo').namFam" type="text" class="for form-control" />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-9 col-12"></div>
          <div class="col-lg-3 col-12">
            <button @click="submitCommunication" class="btn-success btn w-100">ثبت تماس</button>
            
          </div>
        </div>
      </div>
      <div v-if="CommunicationList.length > 0 && !AddMode" class="col-12">
        <div class="row">
          <div class="col-lg-4 col-12">
            <small>فیلتر تماسها</small>
            <SearchableCombo :edit="false" :grp="24" :code="null" @ResultCombo="ChangeSearch" :rownumintable="3" :defaultvalue="DataAxios.ArryfildValue.tblComboGrp24Result" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'Natije'" :keyItem="'Natije'" :disabled="false">
            </SearchableCombo>
          </div>
        </div>
        <BnpGrid v-if="$store.state.renderComponentTicket" :hasRowNum="false" :propsColumn="Column" :propsRows="Allrows" :Selectable="false" :action="true">
          <template slot="tblComboGrp24Resultname" slot-scope="props">
            <span>
              <div :data-title="props.props.tblComboGrp24Resultname">
                <i style="font-size: 20px !important" v-if="props.props.tblComboGrp24Result == 1351" class="fad fa-phone-volume text-warning"></i>
              </div>
              <div :data-title="props.props.tblComboGrp24Resultname">
                <i style="font-size: 20px !important" v-if="props.props.tblComboGrp24Result == 1352" class="fad fa-phone text-danger"></i>
              </div>
              <div :data-title="props.props.tblComboGrp24Resultname">
                <i style="font-size: 20px !important" v-if="props.props.tblComboGrp24Result == 1353" class="fad fa-user-alt-slash text-warning"></i>
              </div>
              <div :data-title="props.props.tblComboGrp24Resultname">
                <i style="font-size: 20px !important" v-if="props.props.tblComboGrp24Result == 1354" class="fad fa-phone-volume text-success"></i>
              </div>
              <div :data-title="props.props.tblComboGrp24Resultname">
                <i style="font-size: 20px !important" v-if="props.props.tblComboGrp24Result == 1355" class="fas fa-envelope-open-text text-light"></i>
              </div>
              <div :data-title="props.props.tblComboGrp24Resultname">
                <i style="font-size: 20px !important" v-if="props.props.tblComboGrp24Result == 1356" class="fas fa-fax text-light"></i>
              </div>
              <div :data-title="props.props.tblComboGrp24Resultname">
                <i style="font-size: 20px !important" v-if="props.props.tblComboGrp24Result == 1357" class="fas fa-paper-plane text-primary"></i>
              </div>
              <div :data-title="props.props.tblComboGrp24Resultname">
                <i style="font-size: 20px !important" v-if="props.props.tblComboGrp24Result == 1365" class="fad fa-phone-slash text-danger"></i>
              </div>
              <div :data-title="props.props.tblComboGrp24Resultname">
                <i style="font-size: 20px !important" v-if="props.props.tblComboGrp24Result == 1366" class="fad fa-power-off text-danger"></i>
              </div>
              <div :data-title="props.props.tblComboGrp24Resultname">
                <i style="font-size: 20px !important" v-if="props.props.tblComboGrp24Result == 1372" class="fad fa-signal text-danger"></i>
              </div>
              <div :data-title="props.props.tblComboGrp24Resultname">
                <i style="font-size: 20px !important" v-if="props.props.tblComboGrp24Result == 1377" class="fas fa-images text-light"></i>
              </div>
              <div :data-title="props.props.tblComboGrp24Resultname">
                <i style="font-size: 20px !important" v-if="props.props.tblComboGrp24Result == 1378" class="fad fa-ban text-danger"></i>
              </div>
              <div :data-title="props.props.tblComboGrp24Resultname">
                <i style="font-size: 20px !important" v-if="props.props.tblComboGrp24Result == 1386" class="fas fa-mailbox text-light"></i>
              </div>
              <div :data-title="props.props.tblComboGrp24Resultname">
                <i style="font-size: 20px !important" v-if="props.props.tblComboGrp24Result == 1447" class="fas fa-desktop text-light"></i>
              </div>
              <div :data-title="props.props.tblComboGrp24Resultname">
                <i style="font-size: 25px !important" v-if="props.props.tblComboGrp24Result == 1465" class="fas fa-sms text-success"></i>
              </div>
              <div :data-title="props.props.tblComboGrp24Resultname">
                <i style="font-size: 20px !important" v-if="props.props.tblComboGrp24Result == 1466" class="fas fa-2x fa-ellipsis-h text-light"></i>
              </div>
            </span>
          </template>
          <template slot="action-slot" slot-scope="props">
            <a v-if="props.props.tblUserGrpIdInsert == $session.get('UserInfo').tblUserGrpId && props.props.DateTimeInsert.substring(0, 10) == $store.state.JalaliDate" @click="Delete(props.props)"> <i class="fas fa-trash"></i></a>
          </template>
        </BnpGrid>
      </div>
    </div>
  </div>
</template>
<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import datePicker from 'vue-persian-datetime-picker'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
export default {
  props: ['CustomerId', 'CommunicationList'],
  data() {
    return {
      AddMode: false,
      Allrows: [],
      Address: [],
      NewCall: {
        Id: 25,
        tblCustomerId: this.CustomerId,
        tblPersonelId: 0,
        tblUserId: this.$session.get('UserInfo').tblUserId,
        tblUserGrpIdLastEdit: 0,
        tblUserGrpIdInsert: this.$session.get('UserInfo').tblUserGrpId,
        Duration: 0,
        Result: '',
        DateTimeLastEdit: ' - ',
        DateTimeInsert: '',
        Date: this.$store.state.JalaliDate,
        Time: null,
        tblComboGrp24Result: 0,
      },
      DataAxios: {
        Action: 'TblCustomerCommunication/Add',
        Method: 'Post',
        ArryfildValue: {},
      },
      rendergrid: true,
      DataAxoisCol: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmCommunications',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      Column: [],
    }
  },
  methods: {
    DeleteCom(data) {
      var DataAxiosDelete = { Method: 'POST', Action: 'TblCustomerCommunication/Delete', ArryfildValue: { ID: data.id } }
      this.$PostData(DataAxiosDelete)
        .then((result) => {
          if (result.status == 'success') {
            this.$toasted.success('تماس حذف شد', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(10000)
                },
              },
            })
            this.$emit('Inserted', {
              done: 'OK',
              activeTab: 3,
            })
          } else {
            this.$toasted.error('مشکلی بوجود آمده است!', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(10000)
                },
              },
            })
          }
        })
        .catch((error) => {
          console.error('خطا', error)
          this.$toasted.error('مشکلی بوجود آمده است!', {
            action: {
              text: 'بستن',
              onClick: (e, toastObject) => {
                toastObject.goAway(10000)
              },
            },
          })
        })
    },
    Delete(data) {
      this.$SweetQustion('اطمینان از تایید', 'تماس حذف شود؟؟', 'warning', 'تایید ', 'انصراف', data, this.DeleteCom, this.cancel)
    },
    addnew() {
      this.DataAxios.ArryfildValue = JSON.parse(JSON.stringify(this.NewCall))
      const today = new Date()
      let time = (today.getHours() < 10 ? '0' : '') + today.getHours() + ':' + (today.getMinutes() < 10 ? '0' : '') + today.getMinutes()
      this.DataAxios.ArryfildValue.Time = time
      this.status = 'add'
    },
    GetResultNatije(data) {
      this.DataAxios.ArryfildValue.tblComboGrp24Result = data.id
    },
    GetResultPersonel(data) {
      if(data.id != null){
        this.DataAxios.ArryfildValue.tblPersonelId = data.id
      }
    },
    submitCommunication() {
      if (this.DataAxios.ArryfildValue.tblComboGrp24Result == 0) {
        this.$mySweetDefaultTost('هشدار', 'نتیجه تماس نمیتواند خالی باشد!', 'warning', 2000)
      } else {
        this.$PostData(this.DataAxios).then((result) => {
          if (result.status == 'success') {
            this.AddMode = false
            this.$mySweetDefaultTost('عملیات موفق', 'تماس جدید با موفقیت ثبت شد', 'success', 2000)
            this.$emit('Inserted', {
              done: 'OK',
              activeTab: 3,
            })
          }
        })
      }
    },
    ChangeSearch(data) {
      if (data.id == null) {
        this.Allrows = JSON.parse(JSON.stringify(this.CommunicationList))
      } else {
        this.Allrows = this.CommunicationList.filter((x) => x.tblComboGrp24Result == data.id)
      }

      this.$store.state.renderComponentTicket = false
      this.$nextTick(() => {
        this.$store.state.renderComponentTicket = true
      })
    },
  },
  beforeMount() {
    this.$GetColumns(this.DataAxoisCol, true)
      .then((data) => {
        this.Allrows = JSON.parse(JSON.stringify(this.CommunicationList))
        this.Column = data
      })
      .finally(() => {
        this.$store.state.renderComponentTicket = false
        this.$nextTick(() => {
          this.$store.state.renderComponentTicket = true
        })
      })
  },

  components: { BnpGrid, datePicker, SearchableCombo, BnpGrid },
}
</script>
